export default import.meta.ROLLDOWN_FILE_URL_Q1RguVLTsn1X_pNUE3gq4g